webpackJsonp([250511821328750],{

/***/ 3813:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"siteName":"Healthful&Inspired","siteUrl":"https://healthfulinspired.com","siteDescription":"Actively sharing the most useful health content for health, wellness, fitness, weight loss, fat burn & diets for people who want to become healthier. Subscribe!"}},"allMarkdownRemark":{"totalCount":2,"edges":[{"node":{"fields":{"slug":"/hip-flexors-unlock"},"frontmatter":{"title":"Unlock Your Hip Flexors","date":"2018-07-27"}}},{"node":{"fields":{"slug":"/unlock-hip-flexors"},"frontmatter":{"title":"Unlock Your Hip Flexors","date":"2018-07-27"}}}]}},"pathContext":{"tag":"trouble sleeping"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-trouble-sleeping-f16ee5e2874e55cb9e69.js